var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 67,
    height: 57,
    viewBox: "0 0 67 57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-153 -926)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(153 925)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8.7,36.405a3.25,3.25,0,0,1,.933,2.6,35.653,35.653,0,0,1-1.293,6.5,38.38,38.38,0,0,0,8.56-2.9,3.25,3.25,0,0,1,2.308-.241A26.2,26.2,0,0,0,26,43.25c12.987,0,22.75-9.123,22.75-19.5S38.987,4.25,26,4.25,3.25,13.376,3.25,23.75A17.862,17.862,0,0,0,8.7,36.405ZM7.1,49.1q-1.155.229-2.317.419A.845.845,0,0,1,3.9,48.339q.433-1.021.793-2.07l.01-.033A33.948,33.948,0,0,0,6.4,38.7,21.111,21.111,0,0,1,0,23.75C0,11.185,11.641,1,26,1S52,11.185,52,23.75,40.358,46.5,26,46.5a29.445,29.445,0,0,1-7.628-.994A44.424,44.424,0,0,1,7.1,49.1Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M4,6.625A1.625,1.625,0,0,1,5.625,5h22.75a1.625,1.625,0,1,1,0,3.25H5.625A1.625,1.625,0,0,1,4,6.625ZM4,14.75a1.625,1.625,0,0,1,1.625-1.625h22.75a1.625,1.625,0,0,1,0,3.25H5.625A1.625,1.625,0,0,1,4,14.75Zm0,8.125A1.625,1.625,0,0,1,5.625,21.25h13a1.625,1.625,0,1,1,0,3.25h-13A1.625,1.625,0,0,1,4,22.875Z",
    transform: "translate(9 9)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M16.5,29.875C8.308,29.875,1.51,24.651.168,17.5c-.093-.472,9.785-5.5,9.785-6.3C15.369,4.389,14.076,6.528,16.5,1,25.612,1,33,7.464,33,15.437a13.4,13.4,0,0,1-4.063,9.487,22.058,22.058,0,0,0,1.59,6.117.537.537,0,0,1-.563.747,30.073,30.073,0,0,1-8.621-2.545,18.686,18.686,0,0,1-4.843.631Z",
    transform: "translate(187 951.205)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chat-icon.9988cf834c0d9c911553127c57cf305a.svg";
export { ForwardRef as ReactComponent };